<div class="flex flex-col w-full">

  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h1 class="text-3xl font-bold tracking-tight dark:text-white">Statystyki</h1>
      <p class="text-secondary mt-1">Analiza danych i statystyki systemu</p>
    </div>
  </div>

  <!-- Content with Vertical Navigation -->
  <div class="bg-card rounded-2xl shadow-lg overflow-hidden">
    <div class="flex flex-col md:flex-row">

      <!-- Vertical Navigation -->
      <div class="w-full md:w-64 border-b md:border-b-0 md:border-r border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
        <div class="flex flex-col p-2">
          <button
            *ngFor="let tab of tabs; let i = index"
            (click)="selectTab(i)"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-all cursor-pointer"
            [ngClass]="{
              'bg-primary-50 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400 font-medium': selectedTabIndex === i,
              'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800': selectedTabIndex !== i
            }">
            <mat-icon [svgIcon]="tab.icon"></mat-icon>
            <span class="flex-1">{{ tab.label }}</span>
          </button>
        </div>
      </div>

      <!-- Content Area -->
      <div class="flex-1 min-w-0 min-h-[500px]">

        <!-- 1. Inne statystyki -->
        <div *ngIf="selectedTabIndex === 0" class="p-6">
          <app-other-statistics></app-other-statistics>
        </div>

        <!-- 2. Przewodnik -->
        <div *ngIf="selectedTabIndex === 1" class="p-6">
          <app-tour-statistics></app-tour-statistics>
        </div>

      </div>
    </div>
  </div>

</div>
